import { useState } from 'react';
import { Loader2, QrCode } from 'lucide-react';
import QRCodeDisplay from './QRCodeDisplay';
import { fetchWithAuth } from '../store/fetchClient';

interface GuestQrPayload {
  qrCodeUrl: string;
}

interface GuestQrLauncherProps {
  selectedStoreId: string | null;
  className?: string;
  onTrigger?: () => void;
}

export default function GuestQrLauncher({ selectedStoreId, className, onTrigger }: GuestQrLauncherProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [qrPayload, setQrPayload] = useState<GuestQrPayload | null>(null);

  const handleOpen = async () => {
    if (!selectedStoreId || loading) {
      return;
    }

    setLoading(true);
    setError(null);
    onTrigger?.();
    try {
      const response = await fetchWithAuth('/api/auth/guest-qr', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ selectedStoreId }),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message || 'Gast-QR konnte nicht erzeugt werden.');
      }

      const data = await response.json();
      setQrPayload({
        qrCodeUrl: data.qrCodeUrl,
      });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Gast-QR konnte nicht erzeugt werden.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => void handleOpen()}
        disabled={!selectedStoreId || loading}
        className={className ?? 'inline-flex items-center gap-2 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm font-medium text-emerald-700 hover:bg-emerald-100 disabled:cursor-not-allowed disabled:opacity-60'}
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <QrCode className="h-4 w-4" />}
        Gast-QR
      </button>

      {error && (
        <div className="fixed bottom-4 right-4 z-[10000] rounded-lg border border-rose-200 bg-white px-4 py-3 text-sm text-rose-700 shadow-lg">
          {error}
        </div>
      )}

      {qrPayload && (
        <QRCodeDisplay
          qrCodeUrl={qrPayload.qrCodeUrl}
          minimal
          onClose={() => setQrPayload(null)}
        />
      )}
    </>
  );
}
